import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
// Cloud React components
import { Form, Select, Button } from 'Components';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { NotificationManager } from 'Components/Notifications';
import { Grid } from '@mui/material';
import { OrderData } from 'Core/data/Helpers';

//actions
import {
    clearRedux,
    mapGeofencesAssignGetUnitGeofence,
    mapGeofencesOpenCloseAssignModal,
    mapGeofencesAssignSave,
    searchUnitsGeofence
} from 'Redux/actions';


const GeofenceAssign = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();

    const assignGeofenceUnit = useRef();

    const {
        open,
        id,
        type,
        unitGeofence,
        loadingUnitGeofence,
        response,
        loadingResponse
    } = useSelector((state) => state.realtimeMapGeofenceAssignRedux);

    const { unitGeofence: units, loadingResponse: loadingUnits } = useSelector((state) => state.realtimeMapGeofenceSettingsViewUnitsModuleRedux);

    const jsonGeofence = useSelector((state) => state.catalogsRealtimeRedux.geofences);
    const loadingGeofenceJson = useSelector((state) => state.catalogsRealtimeRedux.loadingGeofences);

    const [formData, setFormData] = useState({});

    useEffect(() => {
        return () => {
            dispatch(clearRedux("MAP_GEOFENCE_ASSIGN"));
        }
    }, []);

    useEffect(() => {
        if (id && open && type) {
            dispatch(mapGeofencesAssignGetUnitGeofence(id, type));
        }

        if (type === "geofence") {
            dispatch(searchUnitsGeofence())
        }
    }, [id, open, type]);

    useEffect(() => {
        if (response && open) {
            if (response.error) {
                NotificationManager.error(
                    response.message || messages['errorMessage'],
                    messages['error'],
                    3000,
                    null,
                    null,
                    'warning',
                );
            } else {
                NotificationManager.success(
                    messages['map_geofence_geofenceAssign_geofencesAssignedMessage'],
                    messages['success'],
                    3000,
                    null,
                    null,
                    'success',
                );

                if (props.callback) props.callback();
                handleClose();
            }
        }
    }, [response, open]);

    useEffect(() => {
        if (unitGeofence && open) {
            if (unitGeofence.error) {
                NotificationManager.error(
                    messages['errorMessage'],
                    messages['error'],
                    3000,
                    null,
                    null,
                    'warning',
                );
            } else {
                if (type === "unit") {
                    setFormData({ entities: unitGeofence?.geofences || [] });
                } else if (type === "geofence") {
                    setFormData({ entities: unitGeofence?.units || [] });
                }
            }
        }
    }, [unitGeofence, open, type]);

    const handleClose = useCallback(() => {
        dispatch(mapGeofencesOpenCloseAssignModal(false));
        dispatch(clearRedux("MAP_GEOFENCE_ASSIGN"));
    });

    const unitConfig = useCallback(() => {
        let title = ''
        if(!unitGeofence?.polygon){
            title = messages['map_geofence_geofenceAssign_unitVersion_circle']?.replace("{geofencesLimit}", unitGeofence?.geofencesLimit);
        }else{
            title = messages['map_geofence_geofenceAssign_unitVersion']?.replace("{geofencesLimit}", unitGeofence?.geofencesLimit);
        }

        let shapes = [];
        
        if (unitGeofence?.circle) shapes.push(messages['map_geofence_geofenceCreateEdit_circle'].toLowerCase());
        if (unitGeofence?.square) shapes.push(messages['map_geofence_geofenceCreateEdit_square'].toLowerCase());
        if (unitGeofence?.polygon) shapes.push(messages['map_geofence_geofenceCreateEdit_polygon'].toLowerCase());

        title = title?.replace('{shapes}', shapes.join(", "));
        title = title?.replace('{pointsLimit}', unitGeofence?.pointsLimit);

        return title;
    });

    const renderUnit = useCallback(() => {
        return (
            <React.Fragment>
                {
                    unitGeofence &&
                    <div>
                        {unitConfig()}
                    </div>
                }

                <Select
                    id="entities"
                    label={messages['map_geofence_geofenceAssign_geofences']}
                    placeholder={messages['map_geofence_geofenceAssign_geofences']}
                    loading={loadingGeofenceJson}
                    disabled={formData?.entities?.length >= unitGeofence?.geofencesLimit}
                    value={formData.entities || []}
                    onChange={(values) => setFormData({ ...formData, entities: values })}
                    options={jsonGeofence.filter((item) => {
                        //validate circle integrity
                        if(unitGeofence?.circle && item.shape == 'circle'){
                            if(!item?.radius) return false
                        }
            
                        //validate Poligon integrity
                        if(unitGeofence?.polygon && item.shape == 'polygon'){
                            if(!item?.radius && item?.coordinates?.length > (unitGeofence?.pointsLimit + 1)){
                                return false;
                            }
                        }
            
                        //validate square integrity
                        if(unitGeofence?.square && item.shape == 'square' && item?.coordinates?.length - 1 != 4){
                            return false
                        }

                        //is valid shape
                        let isValid = false;
                        if(unitGeofence?.circle && item.shape == 'circle') isValid = true;
                        if(unitGeofence?.polygon && item.shape == 'polygon') isValid = true;
                        if(unitGeofence?.square && item.shape == 'square') isValid = true;
            
                        return isValid;
                    }) || []}
                    multiple
                    textField="name"
                    valueField="id"
                    selectedOptionsBelow
                />

                {
                    formData?.entities?.length >= unitGeofence?.geofencesLimit &&
                    <div className='text-danger'>
                        {messages['map_geofence_geofenceAssign_geofencesLimitReached']}
                    </div>
                }
            </React.Fragment>
        )
    });

    const renderGeofence = useCallback(() => {
        let shape = messages['map_geofence_geofenceAssign_circle'];
        let note = messages['map_geofence_geofenceAssign_geofenceType_circle']?.replace('{shape}', shape);

        if(unitGeofence?.shape == 'square') {
            shape = messages['map_geofence_geofenceAssign_square'];
            note = messages['map_geofence_geofenceAssign_geofenceType_circle']?.replace('{shape}', shape);
        } else if (unitGeofence?.shape == 'polygon') {
            shape = messages['map_geofence_geofenceAssign_polygon'];
            note = messages['map_geofence_geofenceAssign_geofenceType']?.replace('{shape}', shape);
        }

        note = note?.replace('{points}', unitGeofence?.coordinates?.length ? (unitGeofence?.coordinates?.length - 1) :  0);
        return (
            <React.Fragment>
                <div>
                    {`${note}`}
                </div>

                <Select
                    id="entities"
                    label={messages['map_geofence_geofenceAssign_units']}
                    placeholder={messages['map_geofence_geofenceAssign_units']}
                    loading={loadingUnits}
                    value={formData.entities || []}
                    onChange={(values) => setFormData({ ...formData, entities: values})}
                    options={units.filter((item) => {
                        //validate number of geofences
                        if (item.countGeofence >= item.geofencesLimit) {
                            return false;
                        }

                        //validate polygon / points limit
                        if (item?.polygon && ((item?.pointsLimit + 1) < unitGeofence?.coordinates?.length)) {
                            return false;
                        }
                        if (unitGeofence?.shape == 'polygon' && !item?.polygon) {
                            return false;
                        }

                        //validate circle
                        if (unitGeofence?.shape == 'circle' && !item?.circle) {
                            return false;
                        }else if(unitGeofence?.shape == 'circle' && item?.circle && unitGeofence.radius <= 0){
                            return false;
                        }

                        //validate square
                        if (unitGeofence?.shape == 'square' && !item?.square) {
                            return false;
                        }

                        return true;
                    }).map(unit => {
                        return { ...unit, id: unit.unitId };
                    }) || []}
                    multiple
                    textField="name"
                    valueField="id"
                    selectedOptionsBelow
                />
            </React.Fragment>
        );
    });

    let title = `${messages['map_geofence_geofenceAssign_titleUnit']} '${unitGeofence?.name || ""}'`;
    if (type === "geofence") {
        title = `${messages['map_geofence_geofenceAssign_titleGeofence']} '${unitGeofence?.name || ""}'`;
    }

    return (
        <Modal
            title={title}
            open={open}
            loading={loadingUnitGeofence || loadingResponse || loadingGeofenceJson}
            position="right"
            size="small"
            style={{ overflow: 'hidden' }}
            className="overflow-hidden modal-top-0"
            headerStyle={{
                top: 0
            }}
            handleClose={handleClose}
        >
            <ModalBody style={{ marginBottom: 0 }}>
                <div style={{ padding: 24, height: "calc(100vh - 225px)", overflow: "hidden auto" }}>
                    <Form
                        ref={assignGeofenceUnit}
                        onValidSubmit={() => {
                            let data = {};
                            let ids = formData?.entities?.map((entity => {
                                return entity.id
                            }));

                            if (type === "unit") {
                                data = { unitId: parseInt(id), geofenceIds: ids || [] };
                            } else if (type === "geofence") {
                                data = { geofenceId: parseInt(id), unitIds: ids || [] };
                            }

                            dispatch(mapGeofencesAssignSave(data, type));
                        }}
                    >

                        {
                            type === "unit" ? renderUnit() : renderGeofence()
                        }
                    </Form>
                </div>
            </ModalBody>

            <ModalFooter style={{ bottom: 50 }}>
                <Button
                    disabled={loadingUnitGeofence || loadingResponse || loadingGeofenceJson}
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    disabled={loadingUnitGeofence || loadingResponse || loadingGeofenceJson}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        assignGeofenceUnit.current.submit();
                    }}
                    className="btn-blue"
                >
                    {messages['assign']}
                </Button>
            </ModalFooter>
        </Modal >
    )
}

export default GeofenceAssign;